import * as React from 'react'
import { SVGProps } from 'react'

const SvgEarnPiggyBank = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 281 180"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity={0.3}
      d="M174.232 34.365c-40.266-19.87-93.447-31.16-118.267 14.28-22.532 41.223 6.527 90.342 56.24 90.066 21.444-.114 36.338-16.07 58.312-12.819 21.973 3.251 46.262 19.116 63.14-5.271 26.137-37.765-32.928-73.19-59.425-86.256Z"
      fill="#C2FFE7"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M185.542 79.239a42.014 42.014 0 0 0-4.659-4.178l11.423-9.197c1.291-1.039 1.507-2.946.299-4.08a21.502 21.502 0 0 0-32.413 3.48c-7.205-1.922-15.437-2.978-24.621-2.978-38 0-59.714 18.095-59.714 40.714 0 9.177 3.575 17.609 10.36 24.391l-8.086 20.413a3 3 0 0 0 1.147 3.615l9.841 6.44a3 3 0 0 0 4.121-.819l12.273-17.986c8.404 2.978 18.474 4.66 30.058 4.66 10.942 0 20.533-1.5 28.645-4.177l9.629 15.271a3 3 0 0 0 3.595 1.208l11.006-4.147a3 3 0 0 0 1.77-3.811l-6.819-19.217c4.01-3.616 7.046-7.757 9.046-12.27h10.7a3 3 0 0 0 3-3v-32a3 3 0 0 0-3-3h-15.714c-.715 0-1.372.25-1.887.668Z"
      fill="#33DC98"
    />
    <path
      d="M99.245 91.27c-.797-1.26-.555-3.029.575-3.892 6.947-5.309 14.772-8.944 22.999-10.671a53.722 53.722 0 0 1 24.8.635c1.323.349 2.095 1.904 1.739 3.407-.356 1.503-1.705 2.384-3.029 2.04a49.424 49.424 0 0 0-22.626-.534c-7.505 1.576-14.645 4.877-20.996 9.694-1.132.858-2.666.583-3.462-.678Z"
      fill="#fff"
    />
    <ellipse
      cx={104.087}
      cy={52.654}
      rx={26.943}
      ry={26.37}
      transform="rotate(12.717 104.087 52.654)"
      fill="#33DC98"
    />
    <path
      d="m105.923 50.192-3.55.141c-1.565.063-2.884-1.02-2.94-2.414-.055-1.393 1.173-2.578 2.739-2.64l7.099-.283c1.373-.055 2.447-1.09 2.398-2.312-.049-1.222-1.201-2.168-2.574-2.113l-2.839.113-.101-2.527c-.049-1.222-1.201-2.169-2.574-2.114-1.373.055-2.446 1.09-2.397 2.312l.102 2.557c-3.962.48-6.968 3.585-6.824 7.206.153 3.833 3.781 6.813 8.088 6.64l3.55-.14c1.565-.063 2.884 1.02 2.94 2.413.055 1.394-1.173 2.578-2.739 2.64l-7.1.284c-1.373.055-2.446 1.09-2.397 2.312.048 1.221 1.2 2.168 2.574 2.113l2.839-.113.1 2.527c.049 1.222 1.202 2.168 2.574 2.114 1.373-.055 2.446-1.09 2.398-2.312l-.102-2.557c3.962-.48 6.968-3.586 6.824-7.206-.153-3.834-3.781-6.813-8.088-6.641Z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M100.437 38.385c-.069-1.714 1.413-3.021 3.114-3.089 1.702-.068 3.283 1.117 3.351 2.83l.071 1.781 2.092-.083c1.701-.068 3.282 1.116 3.351 2.83.068 1.714-1.414 3.02-3.115 3.089l-7.099.283c-1.238.049-2.058.962-2.022 1.863.036.902.926 1.747 2.163 1.697l3.551-.141c4.635-.185 8.692 3.033 8.864 7.358.154 3.863-2.857 7.094-6.798 7.87l.076 1.893c.068 1.714-1.414 3.02-3.115 3.089-1.701.067-3.282-1.117-3.351-2.831l-.07-1.78-2.093.083c-1.7.068-3.282-1.117-3.35-2.83-.069-1.714 1.413-3.021 3.114-3.09l7.101-.282c1.237-.05 2.057-.962 2.021-1.864-.036-.901-.926-1.746-2.163-1.697l-3.551.142c-4.635.184-8.691-3.033-8.864-7.359-.154-3.862 2.856-7.093 6.797-7.869l-.075-1.893Zm3.174-1.595c-1.044.042-1.71.805-1.68 1.535l.129 3.246-.685.083c-3.653.442-6.292 3.277-6.166 6.434.133 3.342 3.333 6.082 7.311 5.924l3.55-.142c1.894-.075 3.641 1.246 3.717 3.132.075 1.885-1.562 3.341-3.456 3.417l-7.1.283c-1.044.041-1.71.805-1.68 1.535.029.73.752 1.438 1.797 1.396l3.586-.143.13 3.274c.029.73.753 1.438 1.798 1.397 1.044-.042 1.709-.805 1.68-1.535l-.13-3.247.685-.082c3.653-.442 6.293-3.277 6.167-6.434-.133-3.342-3.332-6.083-7.311-5.924l-3.55.141c-1.894.076-3.641-1.245-3.717-3.131-.075-1.885 1.562-3.342 3.456-3.417l7.1-.283c1.044-.042 1.709-.805 1.68-1.535-.029-.73-.753-1.438-1.797-1.397l-3.586.143-.131-3.274c-.029-.73-.753-1.438-1.797-1.396Z"
      fill="#fff"
    />
  </svg>
)

export default SvgEarnPiggyBank
